import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import WorkerPackListAnalysisReportActions from '../../Stores/WorkerPackListAnalysisReport/Actions';

const { Panel } = Collapse;

class WorkerPackListAnalysisReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initWorkerPackListAnalysis } = this.props;

    if (curSiteFlowId > 0) {
      initWorkerPackListAnalysis();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initWorkerPackListAnalysis } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initWorkerPackListAnalysis();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'worker_pack_list_analysis_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

WorkerPackListAnalysisReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initWorkerPackListAnalysis: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

WorkerPackListAnalysisReportScreen.defaultProps = {
  intl: {},
  match: {},

  initWorkerPackListAnalysis: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initWorkerPackListAnalysis: () =>
    dispatch(
      WorkerPackListAnalysisReportActions.workerPackListAnalysisReportInitWorkerPackListAnalysis()
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(WorkerPackListAnalysisReportScreen));
